import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { PlatformEnum } from 'src/utils/environmentStore';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  hideFooter = false;
  year: any;
  constructor(private dataService: DataService) {
    var today = new Date();
    this.year = today.getFullYear();
   }
   _Platform = environment.platForm;
   _PlatformEnum = PlatformEnum;

  ngOnInit() {
    this.dataService.hideFooter.subscribe(value => {
      var self = this;
      setTimeout(() => {
        self.hideFooter = value;
        
      }, 1);
    });
  }

}
